// extracted by mini-css-extract-plugin
export var dot = "_qh-2";
export var wave = "_qh-0";
export var waveSmall = "_qh-1";